import { createSlice } from "@reduxjs/toolkit";

export const registerSlice = createSlice({
  name: "register",
  initialState: {
    isLoading: false,
    isError: false,
    registerData: null,
    message: "",
    status_code: 0,
  },
  reducers: {
    onRegisterUser: (state) => {
      return {
        ...state,
        isLoading: true,
        isError: false,
        registerData: null,
        message: "",
        status_code: 0,
      };
    },

    onRegisterUserSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload;
      return {
        ...state,
        isLoading: false,
        isError: false,
        registerData: data,
        message: message,
        status_code: status_code,
      };
    },

    onRegisterUserError: (state, { payload }) => {
      const { data = null, message = "", status_code = 400 } = payload;
      return {
        ...state,
        isLoading: false,
        isError: true,
        registerData: data,
        message: message,
        status_code: status_code,
      };
    },
    onRegisterUserReset: (state) => {
      return {
        ...state,
        isLoading: false,
        isError: false,
        message: "",
        status_code: null,
      };
    },
    onRegisterDataReset : (state) => {
      return {
        ...state,
        isLoading: false,
        isError: false,
        registerData: null,
        message: "",
        status_code: null,
      };
    },
  },
});

export const {
    onRegisterUser,
  onRegisterUserSuccess,
  onRegisterUserError,
  onRegisterUserReset,
  onRegisterDataReset,
  } = registerSlice.actions;

export default registerSlice.reducer;
